import toast from "react-hot-toast";
export const handleApiError = (response, navigate) => {
  if (response.status_code === "501") {
    toast.error(response.data.error);
  } else if (response.status_code === "422") {
    const errorMessages = Object.values(response.data.error).flat().join(", ");
    toast.error(errorMessages);
  } else if (
    response.data.error?.trim() === "login_session_expire" &&
    response.status_code == "401"
  ) {
    localStorage.removeItem("willguru-token");
    navigate("/");
  }
};
